module.exports = "/build/images/editButtonActive.svg?ebc38a51b2787f5e7d1bebbe9f0d3822";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/editButtonActive.svg
// module id = 2433
// module chunks = 0